/* eslint-disable */
export const PUCK_COLORS_HEX = [
  '#00AB84',
  '#DA291C',
  '#FF6900',
  '#69B3E7',
  '#FC9BB3',
  '#685BC7',
  '#98A4AE',
  '#25282A',
  '#FFB81C',
  '#2B2421',
];

export const PUCK_COLORS_NAME_PAIR = {
  '#00AB84': 'green',
  '#DA291C': 'red',
  '#FF6900': 'orange',
  '#69B3E7': 'blue',
  '#FC9BB3': 'pink',
  '#685BC7': 'purple',
  '#98A4AE': 'grey',
  '#25282A': 'black',
  '#FFB81C': 'yellow',
  '#2B2421': 'autocaption',
};
